import { useIsSearchToFeedEnabled } from '@modules/common/hooks';
import { Box, Link, Typography } from '@mui/material';
import { SEARCH_SUBSCRIPTION_HELPCENTER_URL } from './constants';

export const SearchSubscribeDrawerContentHeader = () => {
  const isSearchToFeedEnabled = useIsSearchToFeedEnabled();

  return (
    <Box>
      <Typography color="text.secondary" component="span" variant="body2">
        Subscribing to a saved {isSearchToFeedEnabled ? 'Feed' : 'Search'} will
        deliver a summary of your customer's voice, along with a relevant
        feedback records at your prescribed cadence.{' '}
      </Typography>
      <Link
        variant="body2"
        href={SEARCH_SUBSCRIPTION_HELPCENTER_URL}
        target="_blank"
        rel="noreferrer"
      >
        Learn More
      </Link>
    </Box>
  );
};
